import script from "./related-zone.vue?vue&type=script&lang=tsx&setup=true"
export * from "./related-zone.vue?vue&type=script&lang=tsx&setup=true"

import "./related-zone.vue?vue&type=style&index=0&id=13e6c858&lang=scss"

const __exports__ = script;

export default __exports__